import { CalendarDay, CalendarTime } from 'further-ui/utils';
import { ActionRef } from 'further-types/lp/action';

export enum VehiclePageTab {
  Overview = 'overview',
  LatestActivity = 'latest-activity',
  Holdings = 'holdings',
  Onboarding = 'onboarding',
}

export type VehicleOverview = {
  totalCommitment: number;
  paidInCapital: number;
  unfundedCommitment: number;
  nonRecallableDistributions: number;
  recallableDistributions: number;
  capitalRefund: number;
};

export type VehicleActivity = {
  id: string;
  vehicleId: string;
  actionRef: ActionRef;
  title: string;
  callToActionTitle: string;
  date: CalendarDay;
  requiresAction: boolean;
  viewedAt?: CalendarTime;
};

export type Holding = {
  id: string;
  assetName: string;
  assetImage: string;
  investmentDate: CalendarDay;
  investedCapitalLcy: number;
  currentHoldValueLcy: number;
  grossMoic: number;
  sector?: string;
  stage?: string;
};
